/**
 * Register API data source wizard — state shapes and the save payload. Same shapes as
 * SharedApiDataSourceWizard (which Masters and Task Import keep using), so the shared Configure and
 * Test & Preview steps and the Register endpoints see exactly what they saw before.
 */
import { FREQUENCY } from '../../../modules/apiSourceRules.js';

const clone = (value) => JSON.parse(JSON.stringify(value));

export function createDefaultConfig() {
  return {
    name: '',
    url: '',
    httpMethod: 'GET',
    requestBody: '',
    headers: [],
    auth: {
      authType: 0,
      apiKeyHeaderName: '',
      apiKeyValue: '',
      bearerToken: '',
      username: '',
      password: '',
      tokenUrl: '',
      clientId: '',
      clientSecret: '',
      scope: '',
    },
    responseDataPath: '',
    pagination: {
      type: 0,
      pageParamName: 'page',
      pageSizeParamName: 'pageSize',
      pageSizeValue: 100,
      offsetParamName: 'offset',
      limitParamName: 'limit',
      limitValue: 100,
      cursorParamName: 'cursor',
      cursorResponsePath: '',
    },
  };
}

export function createDefaultSchedule() {
  return {
    frequency: FREQUENCY.MANUAL,
    hour: 0,
    minute: 0,
    dayOfWeek: 1,
    cronExpression: '',
    triggerImmediate: false,
  };
}

/** Wizard state from a saved ApiDataSourceVM (edit). */
export function stateFromDataSource(ds) {
  const source = ds || {};
  return {
    config: {
      name: source.name || '',
      url: source.url || '',
      httpMethod: source.httpMethod || 'GET',
      requestBody: source.requestBody || '',
      headers: source.headers ? clone(source.headers) : [],
      auth: source.authConfig ? clone(source.authConfig) : { authType: 0 },
      responseDataPath: source.responseDataPath || '',
      pagination: source.paginationConfig ? clone(source.paginationConfig) : { type: 0 },
    },
    mapping: source.fieldMapping ? clone(source.fieldMapping) : null,
    schedule: source.scheduleConfig ? { ...createDefaultSchedule(), ...clone(source.scheduleConfig) } : createDefaultSchedule(),
  };
}

/** CreateApiDataSourceCommand / UpdateApiDataSourceCommand body. */
export function buildSavePayload({ config, mapping, schedule, registerId }) {
  const headers = Array.isArray(config.headers) ? config.headers : [];
  return {
    name: config.name,
    connectionConfig: {
      url: config.url,
      httpMethod: config.httpMethod,
      requestBody: config.requestBody || null,
      headers: headers.filter((header) => header && header.key),
      auth: config.auth,
      responseDataPath: config.responseDataPath || null,
      pagination: config.pagination,
    },
    mapping,
    schedule,
    triggerImmediate: !!schedule.triggerImmediate,
    registerId: registerId || undefined,
  };
}

/** Anything worth confirming before the wizard is discarded. */
export function hasProgress({ step, config }) {
  return step > 1 || !!(config && (config.name || config.url));
}
